<ng-template #authorizationModalTemplate>
  <app-authorization-type-selection [authorizationType]="authorizationType"></app-authorization-type-selection>
</ng-template>
